// Trailing action-column width, shared by the row and the header so they align.
// Can-message rows fit the message button + bookmark; others just the 18px bookmark.
const expertListActionColumnWidth = (canMessage) => (canMessage ? 210 : 18);

export default expertListActionColumnWidth;
